<header class="main__content__header modal-header">
    <h2 class="modal-title">Cartão Digital</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="main__content__modal modal-body">
    <img src="{{picture}}">
</main>
<footer class="modal-footer">
    <button class="btn btn-primary col-xl-2 col-lg-3 px-0" (click)="prints()">
        Imprimir
    </button>
</footer>